export interface IFrontPageMessages {
    dateRange: number;
}

export class FrontPageMessages implements IFrontPageMessages {
    dateRange: number;

    constructor();
    constructor(obj: IFrontPageMessages);
    constructor(obj?: any) {
        this.dateRange = obj && obj.dateRange || 0;
    }
}